import _ from "lodash";
import React, { useEffect, useState } from "react";
import { data, Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAppContext } from "../../Context/AppContext";
import { useSocket } from "../../Context/SocketContext";
import { baseRoute } from "../../Helper";
import { QUIZ_STATUS, WEB_ROUTES } from "../../constants";
import Audience from "./Audience";
import EmptyQuiz from "./EmptyQuiz";
import Game from "./Game";
import Intro from "./Intro";
import RemainingTime from "./RemainingTime";
import { ACCOUNT_ENUM } from './Route';
import Lobby from "./Lobby";
import moment from "moment";

const QuizGame = () => {
    const socket = useSocket()
    const navigate = useNavigate()
    const { user: { id }, isSocketConnected } = useAppContext();
    const location = useLocation()
    const [state, setState] = useState({
        page: ACCOUNT_ENUM.ROLE_SELECTION,
        data: location.state || {}
    })


    useEffect(() => {
        window.history.replaceState({}, "");
    }, [])


    useEffect(() => {
        if (!isSocketConnected || _.isEmpty(state.data)) return;

        socket.on('_quizOver', (data) => {
            if (state.data.id !== data.id) return;

            navigate(baseRoute(WEB_ROUTES.LEADER_BOARD), { replace: true, state: { quiz_id: data.id } })
        })



        return () => {
            if (!isSocketConnected || (state.data.status !== QUIZ_STATUS.ONGOING)) return;

            // socket.emit('_leaveQuizRoom', { quiz_id: state.data.id })
            socket.dispose('_quizOver')
        }
    }, [isSocketConnected, state.data])


    useEffect(() => {

        const handleUnload = () => {
            if (!!state?.data?.id) {
                socket?.emit('_leaveQuizRoom', { quiz_id: state?.data?.id });
            }
        };

        window.addEventListener('beforeunload', handleUnload);

        return () => {
            handleUnload()
            window.removeEventListener('beforeunload', handleUnload);
        }
    }, [])

    const handlePageChange = (route, data) => {
        setState(prev => {
            return {
                ...prev,
                page: route,
                data: {
                    ...prev.data,
                    ...data
                }
            }
        })
    }


    if (!location.state) {
        return <Navigate to={baseRoute(WEB_ROUTES.TUTORIAL_LOGIN)} replace={true} />
    }


    if (state.data.status === QUIZ_STATUS.UPCOMING) {

        if (moment(state.data.start_at).isBefore(moment())) {
            if (state.data.user_id === id) {
                return <Lobby data={location.state} setPage={handlePageChange} />
            }
            else if (!state.data.audience_id) {
                return <Intro data={state.data} setPage={handlePageChange} />
            }
            else {
                <></>
            }
        }
        else {
            return <RemainingTime data={location.state} setPage={handlePageChange} />
        }
    }

    if (state.data.status === QUIZ_STATUS.COMPLETED) {
        return <Navigate to={baseRoute(WEB_ROUTES.LEADER_BOARD)} replace={true} state={{ quiz_id: state.data.id }} />
    }




    if (state.data.user_id === id) {
        if (!state.data.quiz_questions?.length) {
            return <EmptyQuiz data={state.data} />
        }
        else {
            return <Audience data={state.data} />
        }
    }

    switch (state.page) {
        case ACCOUNT_ENUM.LOBBY:
            return <Lobby data={state.data} setPage={handlePageChange} />
        case ACCOUNT_ENUM.ROLE_SELECTION:
            return <Intro data={state.data} setPage={handlePageChange} />
        case ACCOUNT_ENUM.GAME:
            return <Game data={state.data} />
        case ACCOUNT_ENUM.AUDIENCE:
            return <Audience data={state.data} />
        case ACCOUNT_ENUM.EMPTY_QUIZ:
            return <EmptyQuiz data={state.data} />
        default:
            return <Navigate to={baseRoute(WEB_ROUTES.TUTORIAL_LOGIN)} replace={true} />
    }
}

export default QuizGame;